import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { format } from 'date-fns';

import { SessionService } from '../session.service';
import { Pagination } from 'src/app/entities/systems/pagination';

export abstract class ServiceAbs {
  private httpClient: HttpClient;
  protected sessionService: SessionService;
  protected urlPrefix: string;

  constructor(protected injector: Injector) {
    this.httpClient = injector.get(HttpClient);
    this.sessionService = injector.get(SessionService);
    this.urlPrefix = './api/';
  }

  buildSearchFormQuery(data: any) {
    let result = '';
    if (data) {
      for (var p in data) {
        let value = data[p];
        if (value !== undefined && value !== null) {
          if (value instanceof Date) {
            value = format(value, 'yyyy-MM-dd');
          }
          if (value instanceof Array) {
            value.forEach(item => {
              result += '&' + p + '=' + item;
            });
          } else {
            result += '&' + p + '=' + value;
          }
        }
      }
    }
    return result;
  }

  buildPaginationQuery(pagination?: Pagination) {
    let result = '';
    if (pagination) {
      result += '&page_size=' + pagination.size;
      if (pagination.index) {
        result += '&page_index=' + (pagination.index - 1);
      }
    }
    return result;
  }

  protected request<T>(url: string, method: string, data: any = null) {
    return new Promise<T>((resolve, reject) => {
      this.httpClient.request(method, url, {
        responseType: 'json',
        body: data
      }).toPromise().then(r => {
        resolve(<T>r);
      }).catch(e => {
        reject(e);
      });
    });
  }

  private requestDownload(url: string, method: string = 'GET', data?: any) {
    return new Promise<void>((resolve, reject) => {
      this.httpClient.request(method, url, {
        responseType: 'blob',
        observe: 'response',
        body: data
      }).subscribe({
        next: r => {
          if (!r || !r.body || !r.headers) {
            reject('download result is none.');
            return;
          }
          let cd = r.headers.get('Content-disposition');
          if (!cd) {
            reject('Content-disposition is none.');
            return;
          }
          let url = URL.createObjectURL(r.body);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', decodeURIComponent(cd.split('filename=')[1]));
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        },
        error: e => {
          reject(e);
        }
      });
    });
  }

  get<T>(url: string) {
    return this.request<T>(url, 'GET');
  }

  post<T>(url: string, data?: any) {
    return this.request<T>(url, 'POST', data);
  }

  put(url: string, data?: any) {
    return this.request<void>(url, 'PUT', data);
  }

  delete(url: string) {
    return this.request<void>(url, 'DELETE');
  }

  download(url: string, method: string = 'GET', data?: any) {
    return this.requestDownload(url, method, data);
  }
}
